import React from 'react';
import { ReactComponent as CalendarModal } from '../../assets/images/icons/calendarModal.svg';

export default function CalendarModalIcon(props) {
  return (
    <CalendarModal className={`icon ${props.className}`} />
  );
}
